module.exports = "pegasus_template/assets/hexagon-tumblr.png";